module.exports = __webpack_public_path__ + "img/電気回路_4_8_4.48b97bf6.png";